import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const"
import FieldProto from "../../../../../proto/field-proto"
import FieldPopover_InlineEditable from "../../../../popover/render/inline-editable"
import FieldPopover_FormComponent from "../../../../popover/components/form/form-component"
import FieldTimeSpent from "../../time-spent"
import FieldTimeSpent_PopoverContent from "./popover-content"

type Props = {
    parent          : FieldPopover_FormComponent | FieldPopover_InlineEditable
    field           : FieldProto
    value           : any
    model?          : any
    className?      : string
    disabled?       : boolean
    onChange        : callback
    targetOffset?   : any
    options?        : any
    configOptions?  : any
    hideIsBillable? : boolean
    getTargetFunc?  : callback
}

export default function FieldTimeSpent_Popover(props: Props) {
    const popoverPosition = new PopoverPosition({
        attachment      : "top center",
        targetAttachment: "bottom center",
        targetOffset    : props?.targetOffset || "0 0",
        attachmentType  : PopoverAttachmentType.FULL,
    })

    return (
        <Popover
            position                = {popoverPosition}
            outsideClickIgnoreClass = "popover-container"
            onClickOutside          = {props.parent.hidePopover}
            getTargetFunc           = {props.getTargetFunc || (()=>findDOMNode(props.parent))}
        >
            <FieldTimeSpent_PopoverContent
                parent          = {props.parent}
                field           = {props.field as FieldTimeSpent}
                model           = {props.model}
                options         = {props.options}
                configOptions   = {props.configOptions}
                hideIsBillable  = {props.hideIsBillable}
            />
        </Popover>
    )
}
